/** A configured bar count is an upper bound. Only a contiguous prefix may remain. */
export function fittingNavigationCount(
  widths: number[],
  available: number,
  gap: number | number[],
) {
  let used = 0;
  let count = 0;
  for (const width of widths) {
    const next =
      used +
      (count ? (Array.isArray(gap) ? (gap[count - 1] ?? 0) : gap) : 0) +
      width;
    if (
      !Number.isFinite(width) ||
      width <= 0 ||
      next > Math.max(0, available) + 0.25
    )
      break;
    used = next;
    count++;
  }
  return count;
}
